import { apiClient } from '../../../lib/apiClient';

export interface WhatsappConfig {
  id?: number;
  name: string;
  phone_number_id: string;
  waba_id: string;
  access_token: string;
  verify_token: string;
  openai_api_key: string;
  openai_model: string;
  system_prompt: string;
  active: boolean;
  ai_enabled: boolean;
  welcome_message: string;
  business_name: string;
}

export interface WaConversation {
  id: number;
  phone: string;
  customer_name?: string;
  state: string;
  cart?: any[];
  delivery_info?: any;
  last_message_at?: string;
  active: boolean;
  bot_paused?: boolean;
  messages?: WaMessage[];
}

export interface WaMessage {
  id: number;
  role: 'user' | 'assistant';
  content: string;
  sent_at: string;
}

export const getConfig    = async (): Promise<WhatsappConfig | null>  =>
  (await apiClient.get('whatsapp/config')).data;

export const saveConfig   = async (data: Partial<WhatsappConfig>): Promise<WhatsappConfig> =>
  (await apiClient.post('whatsapp/config', data)).data;

export const getWebhookUrl = async (): Promise<{ webhook_url: string }> =>
  (await apiClient.get('whatsapp/webhook-url')).data;

export const listConversations = async (params?: Record<string, unknown>) =>
  (await apiClient.get('whatsapp/conversations', { params })).data;

export const getConversation = async (id: number): Promise<WaConversation> =>
  (await apiClient.get(`whatsapp/conversations/${id}`)).data;

export const sendMessage = async (id: number, message: string) =>
  (await apiClient.post(`whatsapp/conversations/${id}/send`, { message })).data;

export const toggleBot = async (id: number, paused?: boolean) =>
  (await apiClient.post(`whatsapp/conversations/${id}/toggle-bot`, { paused })).data;

export const closeConversation = async (id: number) =>
  (await apiClient.post(`whatsapp/conversations/${id}/close`)).data;

export const testMessage = async (phone: string, message: string) =>
  (await apiClient.post('whatsapp/test', { phone, message })).data;
